import environment from '@/environment';
import { createHeaders, networkRequest } from '@/api/api-utils';
import { ActionData, actionDataSchema } from '@/schemas/actionDataSchema';

export const callAction = async (name: string, args: Record<string, unknown> = {}): Promise<ActionData> => {
  const url = new URL('action', environment.serverBaseUrl);
  const body = {
    name,
    arguments: args,
  };

  const response: unknown = await networkRequest(
    new Request(url, {
      method: 'POST',
      headers: createHeaders(),
      body: JSON.stringify(body),
    })
  );

  return actionDataSchema.parse(response);
};
